import { styled } from 'styled-components';

export const StyledDataAccess = styled.div`
  > div:last-of-type {
    h2 {
      padding: ${({ theme }) => theme.sizing.medium}
        ${({ theme }) => theme.sizing.medium}
        ${({ theme }) => theme.sizing.regular}
        ${({ theme }) => theme.sizing.medium};
    }

    > div {
      padding-top: 0;
    }
  }
`;

export const ApiKey = styled.section`
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  padding: ${({ theme }) => theme.sizing.medium};
  margin-bottom: ${({ theme }) => theme.sizing.small};

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${({ $withFeedback }) => $withFeedback && 'margin-bottom: 0.8rem;'}

    h2 {
      margin: 0;
    }
  }

  p {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.sizing.small};
    margin-bottom: ${({ theme }) => theme.sizing.small};

    svg {
      min-width: 1rem;

      path {
        fill: ${({ theme }) => theme.colours.messaging.warning.main};
      }
    }
  }

  .api-key-container {
    position: relative;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colours.ink.primary.main};

    button {
      position: relative;
      background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
      padding: ${({ theme }) => theme.sizing.small};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        background-color: ${({ theme }) => theme.colours.layering[0].main};
      }
    }

    .clipboard-alert {
      position: absolute;
      font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
      font-weight: 600;
      white-space: nowrap;
      top: 2.0625rem;
      left: 0;
    }
  }
`;

StyledDataAccess.displayName = 'StyledDataAccess';
ApiKey.displayName = 'ApiKey';
